<template>

    <div class="d-header">
			<el-row type="flex" class="maxwith header-banner" justify="space-between" align="middle">
			  <el-col :lg="1"  ><router-link tag="div" to="/List" class="grid-content logo"></router-link></el-col>
			  <el-col :lg="18" ><div class="grid-content">
			    <el-menu
			      :default-active="activeIndex"
			      class="el-menu-demo"
			      mode="horizontal"
			      text-color="#000"

			      active-text-color="#000"
			      @select="handleSelect"
			      router
			    >
          <el-submenu index="3" v-if="this.$store.getters.getRole != 'fenxi'&&this.$store.getters.getRole != 'shijian'&&this.$store.getters.getRole != 'adminj' && this.$store.getters.getRole != 'yuzhou'&& this.$store.getters.getRole != 'ui' && this.$store.getters.getRole != 'webz'" style="background-color:#f36cf5;font-weight: bold;border-left: 4px solid #40E0D0;border-top: 4px solid #40E0D0;" >
             <template  slot="title">下载列表</template>
             <el-menu-item index="List" v-if="this.$store.getters.getRole == 'entry' || this.$store.getters.getRole == 'admin' || this.$store.getters.getRole == 'admins'">Ak列表</el-menu-item>
             <el-menu-item index="Lists" v-if="this.$store.getters.getRole == 'entry' || this.$store.getters.getRole == 'admin' || this.$store.getters.getRole == 'admins'">密码链接列表</el-menu-item>
            
          </el-submenu>
          <el-submenu index="2" v-if="this.$store.getters.getRole != 'fenxi' &&this.$store.getters.getRole != 'shijian'&&this.$store.getters.getRole != 'adminj'&& this.$store.getters.getRole != 'yuzhou'&& this.$store.getters.getRole != 'ui' && this.$store.getters.getRole != 'webz'" style="background-color:#f36cf5;font-weight: bold;border-right: 4px solid #40E0D0;border-top: 4px solid #40E0D0;">
             <template slot="title">上传</template>
             <el-menu-item index="List" v-if="this.$store.getters.getRole == 'entry' || this.$store.getters.getRole == 'admin' || this.$store.getters.getRole == 'admins'">上传</el-menu-item>
             


          </el-submenu>
          
         



          <el-submenu index="10" v-if="this.$store.getters.getRole == 'admins' || this.$store.getters.getRole == 'adminj'"  style="background-color:#f9cb87;font-weight: bold;border-top: 4px solid #40E0D0;bold;border-right: 4px solid #40E0D0;">
             <template slot="title">权限管理</template>
             <el-menu-item index="User" v-if=" this.$store.getters.getRole == 'admins'|| this.$store.getters.getRole == 'adminj'">账号权限</el-menu-item>
             <el-menu-item index="Tj" v-if="this.$store.getters.getRole == 'admins'|| this.$store.getters.getRole == 'adminj'">工作统计</el-menu-item>
             <el-menu-item index="Aasystem" v-if="this.$store.getters.getRole == 'admins'">系统版本</el-menu-item>
          </el-submenu>






			    </el-menu>
			  </div></el-col>
				<el-col :lg="5" class="user-header"  >
						<span class="u-name">{{this.$store.state.userName}}</span>|<span class="out" @click="drawer = true">修改密码</span> |<span class="out" @click="out()">退出</span>
				</el-col>
			</el-row>
			<el-drawer
				title="修改密码"
				:visible.sync="drawer">


				<div class="h-d-word">
					<span>原密码:</span>
					<el-input
						class="h-old-word"
						placeholder="原密码"
						prefix-icon="el-icon-key"
						v-model="oldpassword">
					</el-input>
				</div>
				<div class="h-d-word">
					<span>新密码:</span>
					<el-input
						class="h-new-word"
						placeholder="新密码"
						prefix-icon="el-icon-key"
						v-model="newpassword" show-password>
					</el-input>
				</div>
				<div class="h-confim" @click="changeWord()">确认</div>
			</el-drawer>
		</div>
</template>

<script>
  export default {
    data() {
      return {
        activeIndex: 'Lable',
			  drawer: false,
				newpassword:'',
				oldpassword:'',
      };
    },
    mounted() {
      this.activeIndex = window.location.href.split('/')[3];

      if(this.$store.getters.getRole == 'ui'){
        this.activeIndex = 'Ac'
      }
    },
    watch: {

      $route:function(){
        this.activeIndex = window.location.pathname.substring(1);


      }
    },
    methods: {
      handleSelect(key, keyPath) {

      },

			out(){
				window.localStorage.setItem('token','');
				window.localStorage.setItem('id','');
				window.localStorage.setItem('name','');
				window.localStorage.setItem('role','');
				window.localStorage.clear();
				this.$router.push({ path: '/' })
			},
			changeWord(){
				this.$confirm('确认修改？')
          .then(_ => {
            this.doChange();
          })
          .catch(_ => {});
			},
			doChange(){
				const axiosInstance = this.$axios.create({
					headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
					withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
				});
				axiosInstance({
					method:'get',
					params:{
						newpassword:this.newpassword,
						oldpassword:this.oldpassword,
						token:window.localStorage.getItem('token'),
						userId:window.localStorage.getItem('id')
					},
					url:'http://'+this.$store.getters.getUrl+'/index.php/index/data/changePass'
				})
				.then(res=>{
					if(res.data.code == 200){
					 	this.$message({
					 		type: 'success',
					 		message: '修改成功'
					 	});
					  this.drawer = false;
					 }else{
					 	this.$message({
					 		type: 'error',
					 		message: res.data.msg
					 	});
					 }
				})
				.catch(err=>{

				});
			}

    }

  }
</script>

<style>
	.el-menu{
		float: left;
	}
	.header-banner{

		margin-right: 300px;
	}

	.user-header{
		text-align: left;
	}
	.u-name{
		margin-right: 15px;
	}
	.out{
		color:#3A8EE6;
		margin-left: 15px;
	}
	.h-d-word{
		margin-left: 30px;
	}
	.h-new-word{
		width: 50%;
		margin-left: 10px;
		margin-top: 20px;
	}
	.h-old-word{
		width: 50%;
		margin-left: 10px;
	}
	.h-confim{
		width: 80px;
		height: 40px;
		color: #fff;
		background: #0000FF;
		line-height: 40px;
		border-radius: 8px;
		text-align: center;
		margin-top: 30px;
		margin-left: 45%;
	}
</style>



// WEBPACK FOOTER //
// src/components/header.vue